'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RecommendedFeaturedContent = require('./components/RecommendedFeaturedContent.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RecommendedFeaturedContent).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/recommended-featured-content/lib/index.js
// module id = 1463
// module chunks = 1